// ru-RU
export default {
	title: "Центр подарочных карт",
	myPoints: "Мои баллы",
	SelectedGifts: "Выбранные подарки",
	form: {
		label: {
			title: "Поиск",
			points: "Очки"
		}
	},
	redemption: "Искупление",
	stock: "Запас",
	id: {
		redeemPoints: "Используйте необходимые баллы:",
		btn: "Использовать сейчас",
		title: "Уведомление о покупке",
		content: `Уважаемый работник, благодарим вас за участие в работе.\n\nПеред обменом баллов прочтите следующие условия:\n\n[Рабочие баллы] После ежедневного завершения оптимизации данных набора заказов работники могут заработать 1 подарочный балл, который может использоваться для частичного погашения спонсорского подарка.\n[Погашение подарка] Работникам необходимо предоставить соответствующую информацию об адресе доставки, и подарок будет отправлен бесплатно по всему миру в течение 14 дней. После завершения погашения вы можете связаться со службой поддержки клиентов, чтобы получить номер отслеживания, чтобы отслеживать ход доставки подарка. Платформа не будет раскрывать информацию третьим лицам.\nПримечание: после обмена баллов на подарки они не подлежат возврату`
	},
	applyDialog: {
		title: "Получение информации",
		form: {
			consignee: "Получатель",
			area: "Область",
			telephone: "Телефон",
			deliveryAddress: "Адрес доставки"
		},
		btn: "Отправить"
	},
	records: {
		title: "Записи",
		status: ["Ожидает отправки", "Отправлено", "Доставлено", "Отменено"]
	}
};
